// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueAnalytics from 'vue-analytics'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import VueGtm from 'vue-gtm';
import App from './App.vue'
import router from './router/newindex'
import Sticky from './utilities/directive/sticky';
import VueGeolocation from 'vue-browser-geolocation';
import gtagjs from "./analytics/gtag";
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.config.silent = true

Vue.directive('Sticky', Sticky)


Vue.use(BootstrapVue)
Vue.use(VueAnalytics, {
	id: 'UA-7658330-5',
	router,
	autoTracking: {
		pageviewOnLoad: false
	}
})
Vue.use(VueGoogleMaps, {
	load: {
	  //key:'AIzaSyBbH1IyUWK_2G49dZr4mSQUI1WWxP6ilBo',
	  key: Vue.localStorage.get('GMapAPIKey_JS') ? Vue.localStorage.get('GMapAPIKey_JS') : (window.location.hostname == "eremit.com.my" || window.location.hostname == "www.eremit.com.my") ? "AIzaSyBbH1IyUWK_2G49dZr4mSQUI1WWxP6ilBo" :"AIzaSyCWCGGb1nnjtq_G8IkXFJLVZZvwYg0hHeY",
	  libraries: 'places', // This is required if you use the Autocomplete plugin
	}
  })

const HelloJs = require('hellojs/dist/hello.all.js');
const VueHello = require('vue-hellojs');

HelloJs.init({
	google: '139520759396-giim7ae0lrqanlmepobj2h26jn3t1lka.apps.googleusercontent.com',
	facebook: '832179490470078'
}, {
		redirect_uri: '/account/authcallback/'
	});
Vue.use(VueHello, HelloJs);
Vue.use(VueGeolocation)

Vue.use(VueFacebookPixel, {
	debug: false,
	router: router
})
Vue.analytics.fbq.init('190214625011450', {});

Vue.use(VueGtm, {
	id: 'TM-5TJLGL7', // Your GTM ID
	enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
	debug: false, // Whether or not display console logs debugs (optional)
	vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

gtagjs(router, 
	'UA-7658330-3',
	 {debug: true, scriptId: 'gtagjs'});

window._sessionInterval = null;
if (typeof NodeList !== "undefined" && NodeList.prototype && !NodeList.prototype.forEach) {
	// Yes, there's really no need for `Object.defineProperty` here
	NodeList.prototype.forEach = Array.prototype.forEach;
}

Vue.prototype
	.$getLocation({
		enableHighAccuracy: true, //defaults to false
		timeout: Infinity, //defaults to Infinity
		maximumAge: 0 //defaults to 0
	})
	.then(coordinates => {
		// debugger;
		Vue.http.headers.common["User-Location"] = coordinates.lat + "," + coordinates.lng;
		if(coordinates && coordinates.lat){
			Vue.http.headers.common["IsAllowLocation"] = '1';
		}else{
			Vue.http.headers.common["IsAllowLocation"] = '0';
		}
	})
	.catch(error => {
		console.log(error);
		Vue.http.headers.common["User-Location"] = "";
		Vue.http.headers.common["IsAllowLocation"] ='0';
	});
// window.Vue = new Vue({
// 	el: '#app',
// 	router,
// 	template: '<App/>',
// 	components: {
// 		App
// 	}
// })

Vue.config.productionTip = false

window.Vue = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

 

